<template>
  <div>
    <div class="d-flex flex-wrap" style="max-width: 580px">
      <v-text-field
        v-model="search"
        class="fix-google-chrome mr-2"
        label="รหัส - ชื่อพนักงาน"
        prepend-inner-icon="mdi-magnify"
        clearable
        outlined
        dense
        hide-details
        @input="handleSearch"
      ></v-text-field>
      <v-autocomplete
        v-model="filterOrganization"
        class="fix-google-chrome"
        label="หน่วยงาน"
        :items="organizations"
        item-text="title_th"
        item-value="organization_uuid"
        outlined
        dense
        hide-details
        clearable
        @change="handleFilterOrganization"
        :loading="loadingFilterOrganization"
      >
      </v-autocomplete>
      <v-btn class="ml-2" icon :loading="loading" @click="handleRefresh">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-data-table
      class="mt-4 with-borders"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :headers="headers"
      :items="flattenedRows"
      :options.sync="optionsEmployee"
      :server-items-length="authorityEmployeeSummary.total"
      :items-per-page="10"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      must-sort
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td style="text-align: center" colspan="4">No data available</td>
          </tr>
          <tr v-for="(item, index) in items" :key="index">
            <!-- Employee -->
            <td
              :style="`vertical-align: ${
                item.employeeRowSpan > 1 ? 'top' : 'middle'
              }; padding: 10px 15px`"
              v-if="item.showEmployee"
              :rowspan="item.employeeRowSpan"
            >
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div>{{ item.employeeName }} ({{ item.employeeCode }})</div>
                  <div class="grey--text caption">
                    {{ item.organizationName }}
                  </div>
                </div>
                <div v-if="getEmployeeSyncBlockReason(item.employeeStatus)">
                  <v-btn
                    icon
                    color="warning"
                    small
                    @click="onShowEmployeeStatus(item.employeeStatus)"
                  >
                    <v-icon>mdi-alert</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>

            <!-- Hardware -->
            <td
              :style="`vertical-align: ${
                item.hardwareRowSpan > 1 ? 'top' : 'middle'
              }; padding: 10px 15px`"
              v-if="item.showHardware"
              :rowspan="item.hardwareRowSpan"
            >
              {{ item.hardwareCode }} - {{ item.hardwareTitle }}
            </td>

            <!-- Authority -->
            <td>
              <div>{{ item.authority }}</div>
              <div class="caption grey--text">
                {{ item.accessControlStartTime }} -
                {{ item.accessControlEndTime }}
              </div>
            </td>

            <!-- Timezone -->
            <td>
              <div class="d-flex justify-space-between align-center">
                <div>{{ item.timezone }}</div>
                <div>
                  <v-btn
                    text
                    color="error"
                    @click.stop="onDeleteDevice(item)"
                    :disabled="
                      uiCtrl &&
                      !uiCtrl.isEnable('btn:::authority_hardware:delete')
                    "
                    >ลบ</v-btn
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <ConfirmDialog
      :dialog="confirmDeleteDevice"
      :loading="confirmDeleteDeviceLoading"
      :dialogData="confirmDeleteDeviceData"
      @cancelConfirmDialog="cancelConfirmDeleteDevice"
      @submitConfirmDialog="submitConfirmDeleteDevice"
    />
    <v-dialog v-model="employeeStatusDialog" width="500">
      <v-card v-if="selectedEmployeeStatus">
        <v-card-title class="body-2 grey lighten-2">
          <div class="d-flex align-center">
            <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
            <div>รายละเอียดสถานะพนักงาน</div>
          </div>
        </v-card-title>
        <v-card-text class="py-4">
          <div class="mb-3">
            <div class="caption grey--text">ชื่อพนักงาน</div>
            <div class="body-2 font-weight-medium">
              {{ selectedEmployeeStatus.firstname_th }}
              {{ selectedEmployeeStatus.lastname_th }}
              ({{ selectedEmployeeStatus.employee_code }})
            </div>
          </div>
          <div class="mb-3">
            <div class="caption grey--text">หน่วยงาน</div>
            <div class="body-2">
              {{
                selectedEmployeeStatus.organization
                  ? selectedEmployeeStatus.organization.title_th
                  : '-'
              }}
            </div>
          </div>
          <v-divider class="my-3"></v-divider>
          <div class="mb-3">
            <div class="caption grey--text">สถานะการใช้งาน</div>
            <div
              class="body-2"
              :style="{ color: '#d32f2f', fontWeight: 'bold' }"
            >
              {{ getEmployeeSyncBlockReason(selectedEmployeeStatus) }}
            </div>
          </div>
          <div class="mb-3" v-if="selectedEmployeeStatus.resign_date">
            <div class="caption grey--text">วันที่ลาออก</div>
            <div class="body-2">{{ selectedEmployeeStatus.resign_date }}</div>
          </div>
          <div
            class="mb-3"
            v-if="
              selectedEmployeeStatus.time_attendance_start_time &&
              !getEmployeeSyncBlockReason(selectedEmployeeStatus)?.includes(
                'หมดอายุ'
              )
            "
          >
            <div class="caption grey--text">วันเวลาเริ่มต้น</div>
            <div class="body-2">
              {{
                formatDateTime(
                  selectedEmployeeStatus.time_attendance_start_time
                )
              }}
            </div>
          </div>
          <div
            class="mb-3"
            v-if="selectedEmployeeStatus.time_attendance_end_time"
          >
            <div class="caption grey--text">วันเวลาสิ้นสุด</div>
            <div class="body-2">
              {{
                formatDateTime(selectedEmployeeStatus.time_attendance_end_time)
              }}
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed @click="employeeStatusDialog = false"> ปิด </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    dialogCheckPermissions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: '',
      filterOrganization: null,
      sortBy: ['employeeCode'],
      sortDesc: [false],
      loading: false,
      loadingFilterOrganization: false,
      headers: [
        {
          text: 'พนักงาน',
          align: 'start',
          value: 'employeeCode',
          width: '25%',
        },
        {
          text: 'Device ที่พนักงานใช้งานได้',
          value: 'hardwareName',
          width: '25%',
          sortable: false,
        },
        {
          text: 'กลุ่มสิทธิ์',
          value: 'authority',
          width: '25%',
          sortable: false,
        },
        {
          text: 'ช่วงเวลา',
          value: 'timezone',
          width: '25%',
          sortable: false,
        },
      ],
      optionsEmployee: {},
      confirmDeleteDevice: false,
      confirmDeleteDeviceLoading: false,
      confirmDeleteDeviceData: {},
      employeeStatusDialog: false,
      selectedEmployeeStatus: null,
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    authorityEmployeeSummary() {
      return this.$store.state.accessAuthority.authorityEmployeeSummary
    },
    flattenedRows() {
      const result = []
      const employees = this.authorityEmployeeSummary.employees || []

      employees.forEach((employee) => {
        const employee_uuid = employee.employee_uuid
        const employeeCode = employee.employee_code
        const employeeName = `${employee.firstname_th} ${employee.lastname_th}`
        const organizationName = employee.organization?.title_th || ''

        const hardwares = employee.hardwares || []

        hardwares.forEach((hardware, hardwareIndex) => {
          const hardware_uuid = hardware?.hardware_uuid || ''
          const hardwareCode = hardware?.hardware_code || ''
          const hardwareTitle = hardware?.title_th || ''

          const authorities = hardware.authorities || []

          authorities.forEach((auth, authIndex) => {
            result.push({
              employee_uuid,
              employeeCode,
              employeeName,
              organizationName,
              employeeStatus: employee,
              showEmployee: hardwareIndex === 0 && authIndex === 0,
              employeeRowSpan: hardwares.reduce(
                (total, e) => total + (e.authorities?.length || 1),
                0
              ),
              hardware_uuid,
              hardwareCode,
              hardwareTitle,
              showHardware: authIndex === 0,
              hardwareRowSpan: authorities.length || 1,
              authority: `${auth.authority.authority_code} - ${auth.authority.title_th}`,
              authority_uuid: auth.authority.authority_uuid,
              timezone: `${auth.timezone.timezone_code} - ${auth.timezone.title_th}`,
              accessControlStartTime: auth.authority.access_control_start_time
                ? moment
                    .utc(auth.authority.access_control_start_time)
                    .format('DD/MM/YYYY HH:mm')
                : '',
              accessControlEndTime: auth.authority.access_control_end_time
                ? moment
                    .utc(auth.authority.access_control_end_time)
                    .format('DD/MM/YYYY HH:mm')
                : '',
            })
          })
        })
      })

      return result
    },
  },
  watch: {
    async dialogCheckPermissions(value) {
      if (value) {
        await this.getAuthorityEmployeeSummary()
      }
    },
    optionsEmployee: {
      async handler() {
        await this.getAuthorityEmployeeSummary()
      },
      deep: true,
    },
  },
  async created() {
    try {
      const { company_uuid } = this.$store.state.authentication.company

      this.loadingFilterOrganization = true

      const payload = {
        company_uuid,
        params: {
          dpc: 'access-authority-summary-to-list-organization',
        },
      }

      await this.fetchOrganizations(payload)
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingFilterOrganization = false
    }
  },
  methods: {
    ...mapActions({
      fetchAuthorityEmployeeSummary:
        'accessAuthority/fetchAuthorityEmployeeSummary',
      fetchOrganizations: 'organization/fetchOrganizations',
      deleteAuthorityDeviceMember:
        'accessAuthority/deleteAuthorityDeviceMember',
      fetchAccessAuthority: 'accessAuthority/fetchAccessAuthority',
    }),
    onShowEmployeeStatus(employee) {
      this.selectedEmployeeStatus = employee
      this.employeeStatusDialog = true
    },
    formatDateTime(value) {
      if (!value) {
        return '-'
      }

      const date = moment(value)
      return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : '-'
    },
    getEmployeeSyncBlockReason(employee) {
      const resignDate = employee?.resign_date
      if (resignDate) {
        return 'ลาออก'
      }

      if (employee?.is_active === false || employee?.is_active === 0) {
        return 'ปิดการใช้งาน'
      }

      if (employee?.is_blacklist === true || employee?.is_blacklist === 1) {
        return 'ติด blacklist'
      }

      const startAt = employee?.time_attendance_start_time
      if (startAt) {
        const startMoment = moment(startAt)
        if (startMoment.isValid() && moment().isBefore(startMoment)) {
          return `ยังไม่อนุญาตการใช้งาน วันที่ ${startMoment.format(
            'DD/MM/YYYY HH:mm'
          )}`
        }
      }

      const endAt = employee?.time_attendance_end_time
      if (endAt) {
        const endMoment = moment(endAt)
        if (endMoment.isValid() && moment().isAfter(endMoment)) {
          return `หมดอายุการใช้งาน วันที่ ${endMoment.format(
            'DD/MM/YYYY HH:mm'
          )}`
        }
      }

      return null
    },
    onDeleteDevice(item) {
      this.confirmDeleteDevice = true
      this.confirmDeleteDeviceData = {
        title: 'ยืนยันการลบ',
        text: `คุณต้องการลบ Device`,
        value: `${item.hardwareCode} - ${item.hardwareTitle} จากกลุ่ม ${item.authority}`,
        item: { data: { ...item } },
      }
    },
    cancelConfirmDeleteDevice() {
      this.confirmDeleteDevice = false
    },
    async submitConfirmDeleteDevice({ data }) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.confirmDeleteDeviceLoading = true

        await this.deleteAuthorityDeviceMember({
          company_uuid,
          authority_uuid: data.authority_uuid,
          body: {
            hardware_uuid: data.hardware_uuid,
          },
        })

        const accessAuthority = await this.fetchAccessAuthority({
          company_uuid,
          authority_uuid: data.authority_uuid,
        })

        this.$store.commit(
          'accessAuthority/EDIT_ACCESS_AUTHORITY',
          accessAuthority
        )

        this.optionsEmployee.page = 1
        this.getAuthorityEmployeeSummary()

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 4000,
          message: 'ลบข้อมูลสำเร็จ',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDeleteDeviceLoading = false
        this.confirmDeleteDevice = false
      }
    },
    handleRefresh() {
      this.optionsEmployee.page = 1
      this.getAuthorityEmployeeSummary()
    },
    handleSearch() {
      this.loading = true
      this.getAuthorityEmployeeSummaryBySearch()
    },
    handleFilterOrganization() {
      this.optionsEmployee.page = 1
      this.getAuthorityEmployeeSummary()
    },
    getAuthorityEmployeeSummaryBySearch: _.debounce(function () {
      this.optionsEmployee.page = 1
      this.getAuthorityEmployeeSummary()
    }, 1000),
    async getAuthorityEmployeeSummary() {
      try {
        this.loading = true

        const { sortBy, sortDesc, page, itemsPerPage } = this.optionsEmployee

        let sort = ''
        const sortByKey = sortBy[0] || ''

        const SORT_MAPPING = {
          employeeCode: 'employee_code',
        }

        sort = SORT_MAPPING[sortByKey] || sortByKey

        if (sortDesc.length > 0) {
          if (sortDesc[0]) {
            sort += `,desc`
          } else {
            sort += `,asc`
          }
        }

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            // dpc: '',
            search: this.search || undefined,
            organization_uuid: this.filterOrganization || undefined,
            sort,
            limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
          },
        }

        await this.fetchAuthorityEmployeeSummary(payload)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
  },
  beforeDestroy() {
    if (this.getAuthorityEmployeeSummaryBySearch) {
      this.getAuthorityEmployeeSummaryBySearch.cancel()
    }
  },
}
</script>

<style scoped>
.with-borders >>> table,
.with-borders >>> th,
.with-borders >>> td {
  border: 1px solid #ccc;
  border-collapse: collapse;
}

.with-borders >>> th,
.with-borders >>> td {
  padding: 8px;
}
</style>
